/**
 * API for validating invite tokens
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.familywaffle.com';

export interface InviteValidationResponse {
  valid: boolean;
  senderName?: string;
  senderPictureUrl?: string;
  expiresAt?: string;
  error?: string;
}

/**
 * Validate an invite token
 */
export async function validateInvite(token: string): Promise<InviteValidationResponse> {
  const url = `${API_BASE_URL}/invites/validate/${encodeURIComponent(token)}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    return {
      valid: false,
      error: 'Failed to validate invite',
    };
  }

  // Hono API wraps response in { success, data, requestId }
  const json = await response.json();
  if (json.success && json.data) {
    return json.data as InviteValidationResponse;
  }

  return {
    valid: false,
    error: 'Invalid response format',
  };
}
